import { scrollTo } from "@/components/Nav";
import { useLanguage } from "@/context/LanguageContext";

export default function Footer() {
  const { t, isAr } = useLanguage();
  return (
    <footer data-testid="site-footer" className="bg-[#22262F] text-white/80">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-12 lg:px-8">
        <p
          data-testid="footer-brand"
          className="select-none text-[16vw] font-extrabold lowercase leading-none tracking-tighter text-white/[0.05] lg:text-[9rem]"
        >
          cambroo
        </p>

        <div className="mt-10 grid grid-cols-1 gap-10 border-t border-white/10 pt-10 md:grid-cols-3">
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-brand">
              {isAr ? "كامبرو للتجارة العامة ذ.م.م" : "Cambroo General Trading LLC"}
            </p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/60">
              {t("footer_tagline")}
            </p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-brand">{t("footer_explore")}</p>
            <ul className="mt-3 space-y-2.5 text-sm text-white/70">
              {[
                [t("nav_collection"), "#collection", "collection"],
                [t("nav_products"), "#products", "products"],
                [t("nav_contact"), "#contact", "contact"],
              ].map(([label, href, id]) => (
                <li key={href}>
                  <a
                    href={href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(href);
                    }}
                    data-testid={`footer-link-${id}`}
                    className="transition-colors duration-200 hover:text-brand"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-brand">{t("footer_office")}</p>
            <p className="mt-3 text-sm leading-relaxed text-white/70">
              {t("contact_address")}
              <br />
              <span dir="ltr">{t("contact_phone")}</span>
              <br />
              <a href="mailto:cambroogt1@gmail.com" data-testid="footer-email-link" className="transition-colors duration-200 hover:text-brand">
                cambroogt1@gmail.com
              </a>
              <br />
              {t("contact_hours")}
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/40 md:flex-row md:items-center">
          <p data-testid="footer-copyright">{t("footer_rights")}</p>
          <p>{t("footer_prices")}</p>
        </div>
      </div>
    </footer>
  );
}
